export default __webpack_public_path__ + "static/media/ToyotaType-Semibold.bca602dc.otf";